<template lang="pug">
.insights-highlights-widget.insights-widget
  InsightsRankingWidget(
    label="Top Apps & URLs"
    :widget-key="tools"
    type="proficiency"
    size="small"
    :limit="limit"
    :fetch-data="false"
    :tooltip="tooltip"
    view-more-label="Apps & URLs"
    has-suspicious-feature
    view-more
  )
</template>

<script>
import { INSIGHTS } from '~/app_constants';

import InsightsRankingWidget from './InsightsRankingWidget.vue';

export default {
  name: 'InsightsHighlightsWidget',
  components: {
    InsightsRankingWidget,
  },
  data: () => ({
    categories: INSIGHTS.api.highlights.categories,
    tools: INSIGHTS.api.highlights.tools,
    tooltip: 'Most accessed apps & URLs during the selected time period',
  }),
  computed: {
    limit() {
      return INSIGHTS.parameters.highlightsRankingLimit;
    },
  },
};
</script>
